import { get, writable } from "svelte/store";
import GeoHelper from "../Helpers/GeoHelper";
import roundFloat from "../Helpers/Misc/roundFloat";
import MapLayerGroup from "../Map/Enums/MapLayerGroup";
import VisibilityState from "../Map/Enums/VisibilityState";
import MapLayerManager from "../Map/MapLayerManager";
import MapStore from "../Map/Store";
import ShippingLanesSet from "./ShippingLanesSet";

const ShippingLanesStore = {
	visible: writable(false),
	lastUpdated: writable(Date.now()),
	sets: [],
	startForBounds: (bounds) => {
		const request = new ShippingLanesSet();
		request.setBounds([roundFloat(bounds[0], 1), roundFloat(bounds[1], 1)], [roundFloat(bounds[2], 1), roundFloat(bounds[3], 1)]);
		request.start();
		ShippingLanesStore.lastUpdated.set(Date.now());
	},

	init: () => {
		const map = MapStore.helpers.getMap();

		// Add shipping lanes box boundary.
		map.addSource("shipping_lanes_outlines", {
			type: "geojson",
			data: GeoHelper.emptyGeoJson()
		});
		map.addLayer({
			id: "shipping_lanes_outlines",
			source: "shipping_lanes_outlines",
			type: "line",
			layout: {
				"line-join": "round",
				"line-cap": "round"
			},
			paint: {
				"line-color": "#000000",
				"line-width": 2
			}
		});

		const firstSet = new ShippingLanesSet(); // eslint-disable-line
		ShippingLanesStore.lastUpdated.set(Date.now());
	},

	update: () => {
		const map = MapStore.helpers.getMap();
		if (!map) {
			console.warn("Map not yet initialised.");
			return;
		}

		// remove deleted sets
		// eslint-disable-next-line no-unused-vars
		const deletedSets = ShippingLanesStore.sets.filter((set) => {
			return set.deleted;
		});

		console.log("sets", ShippingLanesStore.sets);
		const outlines = ShippingLanesStore.sets.filter((set) => {
			return !set.deleted && set.visible && set.visibleOutline && set.resultOutline !== null;
		}).map((set) => {
			return set.resultOutline;
		});
		console.log(outlines);
		map.getSource("shipping_lanes_outlines").setData(GeoHelper.emptyGeoJson(outlines));

		const layerIds = [];
		for (let i = 0; i < ShippingLanesStore.sets.length; i++) {
			const set = ShippingLanesStore.sets[i];
			if (set.visible && set.resultImages.length > 0) {
				for (let j = 0; j < set.resultImages.length; j++) {
					const idName = "shipping_lanes_set_" + i + "_tile_" + j;
					if ((set.dirty || set.deleted) && typeof map.getSource(idName) !== "undefined") {
						map.removeLayer(idName);
						map.removeSource(idName);
					}
					if (!set.deleted) {
						layerIds.push(idName);
						if (typeof map.getSource(idName) === "undefined") {
							map.addSource(idName, set.resultImages[j]);
							map.addLayer({
								id: idName,
								source: idName,
								type: "raster",
								paint: {
									"raster-opacity": 1.0,
									"raster-resampling": "nearest"
								}
							},
							"hillshade");
						}
						map.setLayoutProperty(idName, "visibility", ((get(ShippingLanesStore.visible)) ? VisibilityState.VISIBLE : VisibilityState.NONE));
					}
				}
				set.dirty = false;
			}
		}

		map.setLayoutProperty("shipping_lanes_outlines", "visibility", ((get(ShippingLanesStore.visible)) ? VisibilityState.VISIBLE : VisibilityState.NONE));

		// TODO: here and above, use ShippingLanesStore.visible to remove the layers properly.
		MapLayerManager.addLayerGroup(MapLayerGroup.SHIPPING_LANES, [
			...layerIds,
			"shipping_lanes_outlines"
		], [
			...layerIds,
			"shipping_lanes_outlines"
		]);

		ShippingLanesStore.sets = ShippingLanesStore.sets.filter((set) => {
			return set.deleted === false;
		});

		ShippingLanesStore.lastUpdated.set(Date.now());
	}
};
export default ShippingLanesStore;
